(function() {
  'use strict';

  function toPositiveInteger(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isInteger(number) && number > 0 ? number : fallback;
  }

  function getRule(input) {
    return {
      minimum: toPositiveInteger(input.getAttribute('data-tdf-moq-min'), 1),
      increment: toPositiveInteger(input.getAttribute('data-tdf-moq-step'), 1)
    };
  }

  function quantityIsValid(value, rule, allowZero) {
    var quantity = Number(value);

    if (!Number.isInteger(quantity) || quantity < 0) return false;
    if (allowZero && quantity === 0) return true;
    if (quantity < rule.minimum) return false;

    return (quantity - rule.minimum) % rule.increment === 0;
  }

  function errorMessage(rule) {
    if (rule.increment > 1) {
      return (
        'Enter at least ' +
        rule.minimum +
        ', then use increments of ' +
        rule.increment +
        '.'
      );
    }

    return 'The minimum order quantity is ' + rule.minimum + '.';
  }

  function clearError(input) {
    input.removeAttribute('aria-invalid');

    var form = input.closest('[data-product-form]');
    if (form) {
      var productError = form.querySelector('[data-error-message-wrapper]');
      if (productError) {
        productError.classList.add('product-form__error-message-wrapper--hidden');
      }
    }

    var item = input.closest('[data-cart-item]');
    if (item) {
      item.querySelectorAll('[data-tdf-moq-input]').forEach(function(itemInput) {
        itemInput.removeAttribute('aria-invalid');
      });
      item.querySelectorAll('[data-tdf-moq-error]').forEach(function(error) {
        error.parentNode.removeChild(error);
      });
    }
  }

  function showError(input, message) {
    input.setAttribute('aria-invalid', 'true');

    var form = input.closest('[data-product-form]');
    if (form) {
      var productError = form.querySelector('[data-error-message-wrapper]');
      var productErrorText = form.querySelector('[data-error-message]');
      if (productErrorText) productErrorText.textContent = message;
      if (productError) {
        productError.classList.remove(
          'product-form__error-message-wrapper--hidden'
        );
      }
      return;
    }

    var item = input.closest('[data-cart-item]');
    if (!item) return;

    item.querySelectorAll('[data-tdf-moq-input]').forEach(function(itemInput) {
      itemInput.setAttribute('aria-invalid', 'true');

      var quantityWrapper = itemInput.closest('.cart__qty');
      if (!quantityWrapper || quantityWrapper.querySelector('[data-tdf-moq-error]')) {
        return;
      }

      var error = document.createElement('span');
      error.className = 'tdf-moq-inline-error';
      error.setAttribute('data-tdf-moq-error', '');
      error.setAttribute('role', 'alert');
      error.textContent = message;
      quantityWrapper.appendChild(error);
    });
  }

  function validateInput(input, allowZero) {
    var rule = getRule(input);
    var valid = quantityIsValid(input.value, rule, allowZero);

    if (valid) {
      clearError(input);
      return true;
    }

    showError(input, errorMessage(rule));
    return false;
  }

  function validateCart(form) {
    var firstInvalidInput = null;

    form.querySelectorAll('[data-cart-item]').forEach(function(item) {
      var input = item.querySelector('[data-tdf-moq-input][name="updates[]"]');
      if (!input) input = item.querySelector('[data-tdf-moq-input]');

      if (input && !validateInput(input, true) && !firstInvalidInput) {
        firstInvalidInput = input;
      }
    });

    if (firstInvalidInput) {
      firstInvalidInput.focus();
      firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    return true;
  }

  document.addEventListener(
    'change',
    function(event) {
      var input = event.target.closest('[data-tdf-moq-input]');
      if (!input) return;

      var isCartInput = !!input.closest('[data-cart-item]');
      if (!validateInput(input, isCartInput)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.focus();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function(event) {
      var form = event.target;

      if (form.matches('[data-product-form]')) {
        var productInput = form.querySelector('[data-tdf-moq-input]');
        if (productInput && !validateInput(productInput, false)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          productInput.focus();
        }
        return;
      }

      if (form.matches('.cart') && !validateCart(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();
